import * as types from 'modules/dealers/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @typedef {Array<string>} State */

/** @type {State} */
const initialState = [];

/**
 *
 * @param {State} _
 * @param {import("modules/global/generic.types").Action<import("modules/global/generic.types").PageContent<import('modules/dealers/types.js').Dealer>>} param
 * @returns {State}
 */
const updateState = (_, { payload }) => payload.content.map(dealer => dealer.id);

/**
 * @returns State
 */
const resetState = () => initialState;

export default createReducer(initialState, {
  [types.GET_MODAL_DEALERS_SUCCESS]: updateState,
  [types.GET_MODAL_DEALERS_FAILURE]: resetState,
});
